import React from 'react';
import { TypedMemo } from '../../common/types';
import { Cover } from '../../music24/components/primitives/Cover';
import { Panel } from '../../music24/components/primitives/Panel';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the sheet; each part uses its own slice of it */
import styles from './SMLCreationSheet.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface CreationItemCardProps {
  title: string;
  subtitle?: string;
  /** Where this came from — a url, or the catalog. */
  source?: string;
  imageUrl?: string;
}

/** The thing the sheet is working on, once it knows what it is. */
const CreationItemCardComponent: React.FC<CreationItemCardProps> = ({ title, subtitle, source, imageUrl }) => (
  <Panel nested className={styles.card}>
    <Cover src={imageUrl} label={title} size={76} />
    <div className={styles.cardBody}>
      <h3 className={styles.cardTitle}>{title}</h3>
      {subtitle !== undefined && subtitle !== '' && <span className={styles.cardSub}>{subtitle}</span>}
      {source !== undefined && source !== '' && <span className={styles.cardSource}>{source}</span>}
    </div>
  </Panel>
);

export const CreationItemCard = TypedMemo(CreationItemCardComponent);
